import img0 from './0.jpeg';
import img1 from './1.jpeg';
import img2 from './2.jpeg';
import img3 from './3.jpeg';
import img4 from './4.jpeg';
import img5 from './5.jpeg';
import img6 from './6.jpeg';
import img7 from './7.jpeg';

export const images = [img0, img1, img2, img3, img4, img5, img6, img7]